var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSitesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1083 0H5.04302C3.9679 0 3.09229 0.875616 3.09229 1.95074V12.702C3.09229 13.7771 3.9679 14.6527 5.04302 14.6527H19.1083C20.1834 14.6527 21.059 13.7771 21.059 12.702V1.95074C21.059 0.875616 20.1834 0 19.1083 0ZM19.6292 5.19828V12.702C19.6181 12.9901 19.3854 13.234 19.1083 13.234H5.04302C4.76593 13.234 4.54426 13.0123 4.54426 12.7352V5.19828H19.6292ZM19.6071 3.75739H4.54426V1.95074C4.54426 1.67365 4.77701 1.4298 5.04302 1.4298H19.1083C19.3854 1.4298 19.6071 1.65148 19.6071 1.92857V3.74631V3.75739Z",
    fill: "#FF6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89633 2.02832C5.58598 2.02832 5.33105 2.28325 5.33105 2.59359C5.33105 2.90394 5.58598 3.15887 5.89633 3.15887C6.20667 3.15887 6.4616 2.90394 6.4616 2.59359C6.4616 2.28325 6.20667 2.02832 5.89633 2.02832Z",
    fill: "#FF6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52572 2.02832C7.21538 2.02832 6.96045 2.28325 6.96045 2.59359C6.96045 2.90394 7.21538 3.15887 7.52572 3.15887C7.83606 3.15887 8.09099 2.90394 8.09099 2.59359C8.09099 2.28325 7.83606 2.02832 7.52572 2.02832Z",
    fill: "#FF6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15511 2.02832C8.84477 2.02832 8.58984 2.28325 8.58984 2.59359C8.58984 2.90394 8.84477 3.15887 9.15511 3.15887C9.46546 3.15887 9.72039 2.90394 9.72039 2.59359C9.72039 2.28325 9.46546 2.02832 9.15511 2.02832Z",
    fill: "#FF6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9888 2.09483H15.761C15.495 2.09483 15.2622 2.32758 15.2622 2.59359C15.2622 2.8596 15.4839 3.09236 15.761 3.09236H17.9888C18.2548 3.09236 18.4876 2.8596 18.4876 2.59359C18.4876 2.32758 18.2548 2.09483 17.9888 2.09483Z",
    fill: "#FF6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61693 11.9261H10.7955C11.261 11.9261 11.6268 11.5493 11.6268 11.0948V7.32636C11.6268 6.86084 11.2499 6.49508 10.7955 6.49508H6.61693C6.15141 6.49508 5.78564 6.87192 5.78564 7.32636V11.0948C5.78564 11.5603 6.16249 11.9261 6.61693 11.9261ZM7.20436 10.4963V7.91379H10.1748V10.4963H7.20436Z",
    fill: "#FF6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2449 7.93596H17.6562C18.0552 7.93596 18.3766 7.61453 18.3766 7.21552C18.3766 6.8165 18.0552 6.49508 17.6562 6.49508H13.2449C12.8458 6.49508 12.5244 6.8165 12.5244 7.21552C12.5244 7.61453 12.8458 7.93596 13.2449 7.93596Z",
    fill: "#FF6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2449 10.2303H17.6562C18.0552 10.2303 18.3766 9.90887 18.3766 9.49877C18.3545 9.09975 18.033 8.78941 17.6562 8.78941H13.2449C12.8458 8.78941 12.5244 9.11084 12.5244 9.50985C12.5244 9.90887 12.8458 10.2303 13.2449 10.2303Z",
    fill: "#FF6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9136 16.3153H4.56636C2.9703 16.3153 1.6735 15.0185 1.6735 13.4224V4.0234C1.6735 3.55788 1.29665 3.18103 0.831134 3.18103C0.365617 3.18103 -0.0112305 3.55788 -0.0112305 4.0234V13.4335C-0.0112305 15.9495 2.03926 18 4.55527 18H16.9136C17.3792 18 17.756 17.6232 17.756 17.1576C17.756 16.6921 17.3792 16.3153 16.9136 16.3153Z",
    fill: "#FF6F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.048,
    height: 18,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitesIcon);
export default __webpack_public_path__ + "static/media/sites_icon.76dcb0b43a5185b7ce1252613db688ed.svg";
export { ForwardRef as ReactComponent };